export default __webpack_public_path__ + "static/media/hummus_ricecake.ecf6b4eb.jpg";